import DateTime from '~/lib/NewDateTime';
import { type Report, ReportType, TemplateIndex } from './Report.types';
import TStrings from './Reports.i18n';

type ReportConfig = Partial<Omit<Report, 'id'>>;
const EVENTS_START_DATE_TIME_COLUMN_KEY = 'Start Date & Time';
const EVENTS_END_DATE_TIME_COLUMN_KEY = 'End Date & Time';

export function createNewReportConfigForTemplate(
    templateSelected: TemplateIndex,
    aReport?: Report,
): null | ReportConfig {
    if (templateSelected != null) {
        switch (templateSelected) {
            case TemplateIndex.LAST_MONTH_BOOKINGS: {
                const lastMonthStart = DateTime.now()
                    .subtract(1, 'month')
                    .startOf('month');
                const lastMonthEnd = DateTime.now().startOf('month');
                return {
                    name: TStrings.CREATE_LAST_MONTH_BOOKINGS_TEMPLATE_TITLE,
                    type: ReportType.Events,
                    settings: {
                        templateSelected,
                        filterModel: {
                            [EVENTS_START_DATE_TIME_COLUMN_KEY]: {
                                dateFrom: lastMonthStart.format(
                                    'yyyy-MM-dd 00:00:00',
                                ), // i.e "2024-09-01 00:00:00"
                                dateTo: null,
                                filterType: 'date',
                                type: 'greaterThan',
                            },
                            [EVENTS_END_DATE_TIME_COLUMN_KEY]: {
                                dateFrom: lastMonthEnd.format(
                                    'yyyy-MM-dd 00:00:00',
                                ), // i.e : "2024-10-01 00:00:00"
                                dateTo: null,
                                filterType: 'date',
                                type: 'lessThan',
                            },
                        },
                    },
                };
            }
            case TemplateIndex.REVENUE_PER_EVENT_TYPE:
                return {
                    name: TStrings.CREATE_REVENUE_PER_TYPE_TITLE,
                    type: ReportType.Events,
                    settings: { templateSelected },
                };
            case TemplateIndex.ALL_CLIENTS:
                return {
                    name: TStrings.CREATE_ALL_CLIENTS_TEMPLATE_TITLE,
                    type: ReportType.Clients,
                    settings: { templateSelected },
                };
            case TemplateIndex.ALL_CLASSES:
                return {
                    name: TStrings.CREATE_ALL_CLASSES_TEMPLATE_TITLE,
                    type: ReportType.Classes,
                    settings: { templateSelected },
                };
            case TemplateIndex.REVENUE:
                return {
                    name: TStrings.CREATE_REVENUE_TITLE,
                    type: ReportType.Payments,
                    settings: { templateSelected },
                };
            case TemplateIndex.ALL_INVOICES:
                return {
                    name: 'All Invoices',
                    type: ReportType.Invoices,
                    settings: { templateSelected },
                };
            case TemplateIndex.BLANK_TEMPLATE:
            default:
                if (!aReport) {
                    return null;
                }
                return {
                    name: aReport.name,
                    type: aReport.type,
                    settings: { templateSelected },
                };
        }
    }
    return null;
}
